/* officehauss — Kontakt file upload (custom dropzone + Cloudinary unsigned upload).
   Consent-gated: nothing is uploaded before the DSGVO consent box is ticked. */
(function () {
  function initZone(zone) {
    var cloud = zone.getAttribute('data-cloud');
    var preset = zone.getAttribute('data-preset');
    var maxMB = parseFloat(zone.getAttribute('data-max')) || 50;
    var MAX = maxMB * 1024 * 1024;
    var accept = (zone.getAttribute('data-accept') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var T = {
      type: zone.getAttribute('data-err-type') || 'Unsupported file type',
      size: (zone.getAttribute('data-err-size') || 'File too large') + ' (max. ' + maxMB + ' MB)',
      done: zone.getAttribute('data-done') || 'Uploaded',
      uploading: zone.getAttribute('data-uploading') || 'Uploading…',
      wait: zone.getAttribute('data-wait') || 'Wartet auf Einwilligung',
      fail: zone.getAttribute('data-fail') || 'Upload fehlgeschlagen'
    };
    var dz = zone.querySelector('.ohc-dz');
    var input = zone.querySelector('input[type="file"]');
    var list = zone.querySelector('.ohc-files');
    var form = zone.closest('form');
    var submitBtn = form ? form.querySelector('[data-oh-submit]') : null;
    var consent = form ? form.querySelector('#ohc-consent') : null;
    var uploading = 0;
    var counter = 0;
    var items = [];

    function consentOk() { return consent ? consent.checked : true; }
    function fmt(b) { return b < 1048576 ? Math.round(b / 1024) + ' KB' : (b / 1048576).toFixed(1) + ' MB'; }
    function updateSubmit() { if (submitBtn) submitBtn.disabled = !consentOk() || uploading > 0; }

    if (consent) consent.addEventListener('change', function () {
      updateSubmit();
      if (consent.checked) {
        items.forEach(function (it) {
          if (!it.removed && !it.started && it.valid) { it.metaText.textContent = fmt(it.file.size); startUpload(it); }
        });
      }
    });
    updateSubmit();

    if (dz) {
      dz.addEventListener('click', function () { input.click(); });
      dz.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });
      ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('is-drag'); }); });
      dz.addEventListener('drop', function (e) { if (e.dataTransfer) handle(e.dataTransfer.files); });
    }
    if (input) input.addEventListener('change', function () { handle(input.files); input.value = ''; });

    function handle(files) {
      Array.prototype.forEach.call(files, function (file) {
        var typeOk = accept.length === 0 || accept.indexOf(file.type) > -1;
        var sizeOk = file.size <= MAX;
        var valid = typeOk && sizeOk;
        var it = { file: file, valid: valid, removed: false, started: false, done: false, xhr: null, hidden: null, objUrl: null };

        var card = document.createElement('div');
        card.className = 'ohc-file' + (valid ? '' : ' ohc-file--error');

        var thumb = document.createElement('div');
        thumb.className = 'ohc-file__thumb';
        if (valid && file.type.indexOf('image') === 0) {
          it.objUrl = URL.createObjectURL(file);
          var im = document.createElement('img'); im.alt = ''; im.src = it.objUrl;
          im.addEventListener('load', function () { if (it.objUrl) { URL.revokeObjectURL(it.objUrl); it.objUrl = null; } });
          thumb.appendChild(im);
        } else if (valid && file.type.indexOf('video') === 0) {
          it.objUrl = URL.createObjectURL(file);
          var vd = document.createElement('video'); vd.muted = true; vd.playsInline = true; vd.preload = 'metadata'; vd.src = it.objUrl;
          thumb.appendChild(vd);
        } else {
          thumb.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2Z"/></svg>';
        }

        var body = document.createElement('div'); body.className = 'ohc-file__body';
        var name = document.createElement('div'); name.className = 'ohc-file__name'; name.textContent = file.name;
        var meta = document.createElement('div'); meta.className = 'ohc-file__meta';
        var metaText = document.createElement('span');
        metaText.textContent = !typeOk ? T.type : (!sizeOk ? T.size : (consentOk() ? fmt(file.size) : T.wait));
        meta.appendChild(metaText);
        body.appendChild(name); body.appendChild(meta);

        var bar = document.createElement('div'); bar.className = 'ohc-file__bar';
        var bi = document.createElement('i'); bar.appendChild(bi);

        var x = document.createElement('button');
        x.type = 'button'; x.className = 'ohc-file__x'; x.setAttribute('aria-label', 'Entfernen');
        x.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

        card.appendChild(thumb); card.appendChild(body);
        if (valid) body.appendChild(bar);
        card.appendChild(x);
        list.appendChild(card);

        it.card = card; it.meta = meta; it.metaText = metaText; it.bar = bar; it.bi = bi;
        items.push(it);

        x.addEventListener('click', function () {
          it.removed = true;
          if (it.xhr && !it.done) { try { it.xhr.abort(); } catch (e) {} uploading--; updateSubmit(); }
          if (it.hidden && it.hidden.parentNode) it.hidden.parentNode.removeChild(it.hidden);
          if (it.objUrl) { URL.revokeObjectURL(it.objUrl); it.objUrl = null; }
          var idx = items.indexOf(it); if (idx > -1) items.splice(idx, 1);
          card.remove();
        });

        if (valid && consentOk()) startUpload(it);
      });
    }

    function startUpload(it) {
      if (it.removed || it.started) return;
      it.started = true;
      uploading++; updateSubmit();
      it.metaText.textContent = T.uploading;
      it.xhr = upload(it.file,
        function (pct) { it.bi.style.width = pct + '%'; },
        function (url) {
          if (it.removed) return;
          it.done = true; uploading--; counter++;
          it.hidden = document.createElement('input');
          it.hidden.type = 'hidden';
          it.hidden.name = 'contact[Anhang ' + counter + ']';
          it.hidden.value = url;
          if (form) form.appendChild(it.hidden);
          it.meta.innerHTML = '';
          var d = document.createElement('span'); d.className = 'ohc-file__done'; d.textContent = T.done + ' ✓';
          var s = document.createElement('span'); s.textContent = fmt(it.file.size);
          it.meta.appendChild(d); it.meta.appendChild(s);
          if (it.bar.parentNode) it.bar.parentNode.removeChild(it.bar);
          updateSubmit();
        },
        function () {
          if (it.removed) return;
          it.done = true; uploading--;
          it.card.classList.add('ohc-file--error');
          it.metaText.textContent = T.fail;
          if (it.bar.parentNode) it.bar.parentNode.removeChild(it.bar);
          updateSubmit();
        }
      );
    }

    function upload(file, onProgress, onDone, onError) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', preset);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cloud + '/auto/upload');
      xhr.upload.addEventListener('progress', function (e) { if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100)); });
      xhr.addEventListener('load', function () {
        try { var r = JSON.parse(xhr.responseText); if (r && r.secure_url) onDone(r.secure_url); else onError(); }
        catch (err) { onError(); }
      });
      xhr.addEventListener('error', onError);
      xhr.send(fd);
      return xhr;
    }
  }

  function boot() {
    document.querySelectorAll('[data-oh-upload]').forEach(initZone);
    document.querySelectorAll('#ohc-consent').forEach(function (c) {
      var form = c.closest('form');
      if (!form || form.querySelector('[data-oh-upload]')) return;
      var btn = form.querySelector('[data-oh-submit]');
      if (!btn) return;
      function upd() { btn.disabled = !c.checked; }
      c.addEventListener('change', upd); upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
